import { useMutation } from '@tanstack/react-query';
import { CALCULATIONS_MUTATION_KEY } from 'services/calculations/mutationKey';

import { BalanceSheetApi } from '../balanceSheet.api';

export const useGetPpeAssetsCalculations = () => {
  return useMutation({
    mutationKey: CALCULATIONS_MUTATION_KEY,
    mutationFn: BalanceSheetApi.getPpeAssetsCalculations,
  });
};
